'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _contacts = require('redux/modules/contacts');

var contactsActions = _interopRequireWildcard(_contacts);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _reactRouterRedux = require('react-router-redux');

var _utils = require('helpers/utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupsList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    groupsList: state.contacts.groupsListData,
    groupsListLoading: state.contacts.groupsListLoading,
    deleteGroupLoading: state.contacts.deleteGroupLoading,
    deleteGroupActionData: state.contacts.deleteGroupActionData
  };
}, (0, _extends3.default)({}, contactsActions, { pushState: _reactRouterRedux.push })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(GroupsList, _Component);

  function GroupsList() {
    (0, _classCallCheck3.default)(this, GroupsList);
    return (0, _possibleConstructorReturn3.default)(this, (GroupsList.__proto__ || (0, _getPrototypeOf2.default)(GroupsList)).apply(this, arguments));
  }

  (0, _createClass3.default)(GroupsList, [{
    key: 'gotoGroup',
    value: function gotoGroup(e, group) {
      (0, _utils.stopEvent)(e);
      this.props.pushState('/contacts/groups/' + group.id);
    }
  }, {
    key: 'deleteGroup',
    value: function deleteGroup(group) {
      var _props = this.props,
          deleteGroup = _props.deleteGroup,
          t = _props.t;

      var toastrConfirmOptions = {
        onOk: function onOk() {
          return deleteGroup(group.id);
        },
        onCancel: function onCancel() {}
      };
      _toastr2.default.confirm(t('Are you sure you want to delete this group?'), toastrConfirmOptions);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          t = _props2.t,
          groupsList = _props2.groupsList,
          deleteGroupLoading = _props2.deleteGroupLoading,
          deleteGroupActionData = _props2.deleteGroupActionData,
          groupsListLoading = _props2.groupsListLoading;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _components.List,
          null,
          _react2.default.createElement(
            _components.ListItem,
            { fullWidth: true, isTitle: true },
            _react2.default.createElement(
              'div',
              null,
              t('Group Name')
            ),
            _react2.default.createElement('div', null)
          ),
          groupsList.map(function (group) {
            return _react2.default.createElement(
              _components.ListItem,
              { fullWidth: true, key: group.id, onClick: function onClick(e) {
                  return _this2.gotoGroup(e, group);
                }, className: 'cursor-pointer' },
              _react2.default.createElement(
                'div',
                null,
                group.name
              ),
              _react2.default.createElement(
                'div',
                { className: 'moreCell' },
                _react2.default.createElement('i', { className: 'more', onClick: function onClick(e) {
                    return _this2.groupPopover.toggle(e, group);
                  } }),
                deleteGroupLoading && deleteGroupActionData.groupId === group.id && _react2.default.createElement(_components.Loader, { small: true, mask: true })
              )
            );
          })
        ),
        groupsListLoading && _react2.default.createElement(_components.Loader, null),
        _react2.default.createElement(
          _components.PopoverMenu,
          { id: 'groupPopover', ref: function ref(el) {
              return _this2.groupPopover = el;
            } },
          _react2.default.createElement(
            'li',
            { onClick: function onClick(e) {
                return _this2.gotoGroup(e, _this2.groupPopover.data);
              } },
            t('Edit'),
            _react2.default.createElement('i', { className: 'icon-mode-edit' })
          ),
          _react2.default.createElement(
            'li',
            { onClick: function onClick() {
                return _this2.deleteGroup(_this2.groupPopover.data);
              } },
            t('Delete'),
            _react2.default.createElement('i', { className: 'icon-delete' })
          )
        )
      );
    }
  }]);
  return GroupsList;
}(_react.Component), _class2.propTypes = {
  deleteGroup: _propTypes2.default.func,
  deleteGroupActionData: _propTypes2.default.object,
  deleteGroupLoading: _propTypes2.default.bool,
  groupsList: _propTypes2.default.array,
  groupsListLoading: _propTypes2.default.bool,
  pushState: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _temp)) || _class) || _class);
exports.default = GroupsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Contacts/GroupsList.js
// module id = 1976
// module chunks = 1